 <!-- src/Api.svelte -->
<script context="module">
  import { API_BASE_URL } from '../config';
  import { usersStore, gostergelerStore, formullerStore, degerlerStore, userGosStore } from './stores/stores';
  // import { notifications } from './layouts/Admin.svelte';
  import {notifications} from './stores/notifications';
  import { getGostergeData, getAuthorizedData } from '../src/mw/check';


  // Yönetim paneli için veri listeleme


  export async function login(uname, password) {
    const pathApi = `${API_BASE_URL}/users/auth`;

    try {
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "uname": uname, "password": password })
      });

      if (!response.ok) {
        // throw new Error('Kullanıcı Adı ve Şifrenizi Kontrol ediniz.');
        const errorResponse = await response.json();
        const errorMessage = `${errorResponse.error.message}: ${errorResponse.error.description}`;
        // notifications.warning(errorMessage);
        // console.log(errorResponse);
        throw new Error(`${errorMessage}`);
      }

      const rdata = await response.json();
      notifications.success(`Gİriş Başarılı`, 3000)

      return rdata;
      
    } catch (error) {
      notifications.warning(error || 'Bir hata oluştu.', 5000);
      throw new Error(error || 'Bir hata oluştu.');
    }
  }



  export async function checkUserRoles(cRoles) {
    const pathApi = `${API_BASE_URL}/users/checkroles`;

    const token = localStorage.getItem('token');
    const uid = localStorage.getItem('uid');
    // console.log(token);
    try {
        const response = await fetch(pathApi, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ "_id": uid, "roles": cRoles })
        });

        if (!response.ok) {
            if (response.status === 401) {
                // 401 hatasını bastır
                console.clear();  // Konsolu temizler
                // console.log("Yetkisiz erişim hatası gizlendi.");
            } else {
                notifications.warning('Yetkisiz erişim veya başka bir hata oluştu.', 5000);
            }
            return false;
        }

        const crdata = await response.json();
        return true;
    } catch (error) {
        notifications.warning('Bir hata oluştu.', 5000);
        return false;
    }
}



  export async function rolesUserRoles(id) {
    const pathApi = `${API_BASE_URL}/users/userroles`;

    try {
      const token = localStorage.getItem('token');
      console.log('Token:', token);  // Debug için token'ı yazdır
      // console.log('Kullanıcı ID:', id);  // Debug için kullanıcı ID'sini yazdır
      
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ "id": id })
      });

      if (!response.ok) {
        console.error('API çağrısı başarısız oldu:', response.statusText);  // Hata mesajını yazdır
        return false;
      }

      const responseData = await response.json();
      const urdata = responseData.data;  // 'urdata' burada tanımlanıyor
      // console.log('API yanıtı:', urdata);  // Debug için API yanıtını yazdır
      return urdata;
    } catch (error) {
      // console.error('Bir hata oluştu:', error.message);  // Hata mesajını yazdır
      notifications.warning(error || 'Bir hata oluştu.', 5000);
      throw new Error(error || 'Bir hata oluştu.');
    }
  }

  export async function userList() {
    const pathApi = `${API_BASE_URL}/users`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({ "_id": uid })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const users = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        // notifications({ mode: 'success', message: 'Liste çekildi!', lifetime: 2 });
        return users;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.');
      throw new Error(error.message || 'Bir hata oluştu.');
    }
  }
  export async function userDell(id) {
    const pathApi = `${API_BASE_URL}/users/delete`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
         body: JSON.stringify({ "_id": id })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const users = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        notifications.success(`Kullanıcı Silindi`, 3000)

        return users;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');
    }
  }
  export async function userUpdate(_id,  tel, first_name, last_name, checkedValue, roles) {
    const pathApi = `${API_BASE_URL}/users/update`;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          "_id": _id,
          "phone_number": tel,
          "first_name": first_name,
          "last_name": last_name,
          "phone_number": tel,
          "is_active": checkedValue,
          "roles": roles
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        // API'den dönen hata mesajlarını birleştirin
        const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
        throw new Error(errorMessage);
      }

      // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
      const users = await userList();
      usersStore.set(users);  // Store'u güncelle
      notifications.success(`${JSON.stringify({username})}-Kullanıcı Güncellendi`, 3000);

      return users;
    } catch (error) {
      notifications.warning(error);
      throw new Error(error || 'Bir hata oluştu.');
    }
  }

  export async function userAdd(username, tel, first_name, last_name, roles) {
  const pathApi = `${API_BASE_URL}/users/add`;

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(pathApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "uname": username,
        "first_name": first_name,
        "last_name": last_name,
        "phone_number": tel,
        "roles": roles
      })
    });

    const responseData = await response.json();

    if (!response.ok) {
      // API'den dönen hata mesajlarını birleştirin
      const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
      notifications.warning(errorMessage);
      throw new Error(errorMessage);
    }

    // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
    const users = await userList();
    usersStore.set(users);  // Store'u güncelle
    notifications.success(`${JSON.stringify({username})}-Kullanıcı Eklendi`, 3000);

    return users;
  } catch (error) {
    notifications.warning(error.message);
    throw new Error(error.message || 'Bir hata oluştu.');
  }
  }

  export async function roleList() {
    const pathApi = `${API_BASE_URL}/roles`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({ "_id": uid })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const roles = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        return roles;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }
  export async function rpList(role_id) {
    const pathApi = `${API_BASE_URL}/roles/rp`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
       body: JSON.stringify({ "role_id": role_id })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const rps = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        // console.log(rps);
        return rps;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }
  export async function rolePrives() {
    const pathApi = `${API_BASE_URL}/roles/role_privileges`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      //  body: JSON.stringify({ "role_id": role_id })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const yetki = responseData.privileges; // Sadece "data" alanındaki kullanıcı verilerini al
        const keys = yetki.map(privilege => privilege.key);
      //  console.log(keys);
        return keys;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }


  export async function gostergeList() {
    const pathApi = `${API_BASE_URL}/gostergeler`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({ "_id": uid })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const gostergeler = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        return gostergeler;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }
  export async function gostergeAdd(selectedBoyut, name, tanim, kaynak, deger_sayisi) {
  const pathApi = `${API_BASE_URL}/gostergeler/add`;

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(pathApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "boyut_id": selectedBoyut,
        "name": name,
        "tanim": tanim,
        "kaynak": kaynak,
        "deger_sayisi": deger_sayisi
      })
    });

    const responseData = await response.json();

    if (!response.ok) {
      const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
      // notifications.warning(errorMessage);
      throw new Error(errorMessage);
    }
    let gostergeler = await gostergeList();
    gostergeler = await getGostergeData(gostergeler);
    console.log('g:', gostergeler);

    gostergelerStore.set(gostergeler);
    // console.log(gostergelerStore);
    notifications.success(`${name}-Gösterge Güncellendi`, 3000);

    return gostergeler;
  } catch (error) {
    notifications.warning(error.message);
    throw new Error(error.message || 'Bir hata oluştu.');
  }
}
  export async function gostergeUpdate(_id, boyut_id, name, tanim, kaynak, deger_sayisi) {
  const pathApi = `${API_BASE_URL}/gostergeler/update`;

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(pathApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "_id": _id,
        "boyut_id": boyut_id,
        "name": name,
        "tanim": tanim,
        "kaynak": kaynak,
        "deger_sayisi": deger_sayisi
      })
    });

    const responseData = await response.json();

    if (!response.ok) {
      const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
      // notifications.warning(errorMessage);
      throw new Error(errorMessage);
    }
    let gostergeler = await gostergeList();
    gostergeler = await getGostergeData(gostergeler);
    console.log('g:', gostergeler);

    gostergelerStore.set(gostergeler);
    // console.log(gostergelerStore);
    notifications.success(`${name}-Gösterge Güncellendi`, 3000);

    return gostergeler;
  } catch (error) {
    notifications.warning(error.message);
    throw new Error(error.message || 'Bir hata oluştu.');
  }
}

  export async function boyutList() {
    const pathApi = `${API_BASE_URL}/boyutlar`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({ "_id": uid })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const boyutlar = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        // const boyutlari = boyutlar.map(b=>);

        return boyutlar;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }

  
  export async function formulList() {
    const pathApi = `${API_BASE_URL}/formuller`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({ "_id": uid })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const formuller = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        return formuller;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }
  export async function formulAdd(selectedGosterge, formul, degiskenler) {
  const pathApi = `${API_BASE_URL}/formuller/add`;

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(pathApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "gosterge_id": selectedGosterge,
        "formul": formul,
        "degiskenler": degiskenler
      })
    });

    const responseData = await response.json();

    if (!response.ok) {
      // API'den dönen hata mesajlarını birleştirin
      const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
      throw new Error(errorMessage);
    }


    // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
    const formuller = await formulList();
    formullerStore.set(formuller);  // Store'u güncelle
    notifications.success(`${formul}-Formül Eklendi`, 3000);

    return formuller;
  } catch (error) {
    notifications.warning(error.message);
    throw new Error(error.message || 'Bir hata oluştu.');
  }
  }
  export async function formulUpdate(_id, selectedGosterge, formul, degiskenler) {
    const pathApi = `${API_BASE_URL}/formuller/update`;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          "_id": _id,
          "gosterge_id": selectedGosterge,
          "formul": formul,
          "degiskenler": degiskenler
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        // API'den dönen hata mesajlarını birleştirin
        const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
        // notifications.warning(errorMessage);
        throw new Error(errorMessage);
      }

      // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
      const formuller = await formulList();
      formullerStore.set(formuller);  // Store'u güncelle
      notifications.success(`${formuller}-Formuller Eklendi`, 3000);

      return formuller;
    } catch (error) {
      notifications.warning(error.message);
      throw new Error(error.message || 'Bir hata oluştu.');
    }
  }
  export async function formulDell(id, g_id) {
    const pathApi = `${API_BASE_URL}/formuller/delete`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
         body: JSON.stringify({ 
          "_id": id,
          "gosterge_id": g_id

          })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const formuller = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        notifications.success(`Kullanıcı Silindi`, 3000)

        return formuller;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');
    }
  }

  export async function degerList() {
    const pathApi = `${API_BASE_URL}/degerler`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({ "_id": uid })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const degerler = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        return degerler;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }
  export async function degerAdd(selectedDegerGosterge, yil, veriler) {
  const pathApi = `${API_BASE_URL}/degerler/add`;
 console.log(selectedDegerGosterge, yil, veriler)
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(pathApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "gosterge_id": selectedDegerGosterge,
        "yil": yil,
        "veriler": veriler
      })
    });

    const responseData = await response.json();

    if (!response.ok) {
      // API'den dönen hata mesajlarını birleştirin
      const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
      // notifications.warning(errorMessage);
      throw new Error(errorMessage);
    }


    // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
    let degerler = await degerList();
    degerler = await getAuthorizedData(degerler);
    degerlerStore.set(degerler);  // Store'u güncelle
    notifications.success(`${yil}-${Object.toString(veriler)}-veriler Eklendi`, 3000);

    return degerler;
  } catch (error) {
    notifications.warning(error.message);
    throw new Error(error.message || 'Bir hata oluştu.');
  }
  }
  export async function degerUpdate(_id, selectedGosterge, yil, veriler) {
    const pathApi = `${API_BASE_URL}/degerler/update`;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          "_id": _id,
          "gosterge_id": selectedGosterge,
          "yil": yil,
          "veriler": veriler
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        // API'den dönen hata mesajlarını birleştirin
        const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
        // notifications.warning(errorMessage);
        throw new Error(errorMessage);
      }

      // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
      let degerler = await degerList();
      degerler = await getAuthorizedData(degerler);
      degerlerStore.set(degerler);  // Store'u güncelle
      notifications.success(`${JSON.stringify({ yil, veriler })}-Formuller Güncellendi`, 3000);

      return degerler;
    } catch (error) {
      notifications.warning(error.message);
      throw new Error(error.message || 'Bir hata oluştu.');
    }
  }
  export async function degerDell(id, g_id) {
    const pathApi = `${API_BASE_URL}/degerler/delete`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
         body: JSON.stringify({ 
          "_id": id,
          "gosterge_id": g_id
          })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
      const degerler = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
      let degerlist = await degerList();
      degerlist = await getAuthorizedData(degerlist);
      degerlerStore.set(degerlist);  // Store'u güncelle

      notifications.success(`Değer Silindi`, 3000);
      return degerler;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');
    }
  }


  export async function userGostergeList() {
    const pathApi = `${API_BASE_URL}/usergosterge`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({ "_id": uid })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        // console.log('API yanıtı:', responseData);  // Debug için API yanıtını yazdır
        const usergosterge = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        return usergosterge;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');

    }
  }
  export async function userGostergeAdd(userID, uGs) {
  const pathApi = `${API_BASE_URL}/usergosterge/add`;

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(pathApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "userID": userID,
        "uGs": uGs
      })
    });

    const responseData = await response.json();

    if (!response.ok) {
      // API'den dönen hata mesajlarını birleştirin
      const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
      // console.log(`${errorMessage}:response`);

      // notifications.warning(`${errorMessage}:response`);
      throw new Error(errorMessage);
    }

    const success = responseData.data.success;

   // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
    const userGostergeler = await userGostergeList();
    userGosStore.set(userGostergeler);  // Store'u güncelle
    // notifications.success(`${uGs}-Göstergeler Eklendi`, 3000);
    notifications.success(`Göstergeler Eklendi`, 3000);

    return userGostergeler;
  } catch (error) {
    notifications.warning(`Bir Hata Oluştu: ${error}`);
    // console.log(`${error}: catch`)
    throw new Error(error.message || 'Bir hata oluştu.');
  }
  }
  export async function userGostergeUpdate(_id, selectedGosterge) {
    const pathApi = `${API_BASE_URL}/usergosterge/update`;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          "userID": _id,
          "uGs": selectedGosterge
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        // API'den dönen hata mesajlarını birleştirin
        const errorMessage = `${responseData.error.message}: ${responseData.error.description}`;
        // notifications.warning(errorMessage);
        throw new Error(errorMessage);
      }

      const success = responseData.data.success;

      // Başarılı olduğunda, sadece kullanıcıları yeniden getir ve store'u güncelle
      const usergosterge = await userGostergeList();
      userGosStore.set(usergosterge);  // Store'u güncelle
      notifications.success(`${usergosterge}-User Göstergeler Güncellendi`, 3000);

      return usergosterge;
    } catch (error) {
      notifications.warning(error);
      throw new Error(error || 'Bir hata oluştu.');
    }
  }
  export async function userGostergeDell(id) {
    const pathApi = `${API_BASE_URL}/usergosterge/delete`;

    try {
      const token = localStorage.getItem('token');
      const uid = localStorage.getItem('uid');
      // console.log(token);
      const response = await fetch(pathApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
         body: JSON.stringify({ "_id": id })
      });

      if (!response.ok) {
        return false;
      }

      const responseData = await response.json();
        const degerler = responseData.data; // Sadece "data" alanındaki kullanıcı verilerini al
        notifications.success(`Gösterge Silindi`, 3000)

        return degerler;
    } catch (error) {
      notifications.warning(error.message || 'Bir hata oluştu.', 5000);
      throw new Error(error.message || 'Bir hata oluştu.');
    }
  }



</script>
